import { createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "../../../firebase/config";
import { TalesArea } from "../../../utils/types/TalesArea";

export const toggleAreaVisibility = createAsyncThunk(
  "aree/toggleVisibility",
  async (area: TalesArea) => {
    try {
      const querySnapshot = await db
        .collection("aree")
        .where("title", "==", area.title)
        .get();

      return querySnapshot.docs[0].ref.set({ ...area, show: !area.show });
    } catch (e: any) {
      console.log(e);

      return Promise.reject(
        `Area non ${area.show ? "nascosta" : "mostrata"}, ${e.message}`,
      );
    }
  },
);
